export default "/images/cb66d7d4ccca8c53156c9b0c402995c4.avif";